<nk-card>
  <nk-card-content>
    @if (isLoading()) {
      <nk-progress [isLoading]="isLoading()"></nk-progress>
    }
    @if (src$ | async; as src) {
      @if (printView() && screeningEntityUrl(); as url) {
        <p class="mb-2">
          <i class="fa fa-external-link me-1"></i>
          {{ 'screening.case.review.open_link_in_browser' | translate }}:
          <a href="{{ url }}" target="_blank" rel="noopener">{{ url }}</a>
        </p>
      } @else {
        <div class="d-flex justify-content-end align-items-center mb-2">
          <button nkButton color="secondary" (click)="downloadPdf(screeningCaseComposite(), src)">
            {{ 'screening.case.review.download_pdf' | translate }} <i class="fa fa-download"></i>
          </button>
        </div>
        <div>
          <pdf-viewer
            class="pdf-view"
            [src]="src"
            [render-text]="true"
            [fit-to-page]="true"
            [zoom]="0.9"
            [original-size]="false"></pdf-viewer>
        </div>
      }
    } @else {
      @if (!isLoading()) {
        <div class="alert alert-warning">
          {{ 'screening.case.review.pdf.not_found' | translate }}
        </div>
      }
    }

    @if (error(); as error) {
      <nk-error-alert [error]="error"></nk-error-alert>
    }
  </nk-card-content>
</nk-card>
